import { useParams, useSearchParams } from 'react-router-dom'

import UserPart from '@/compoments/common/UserPart'
import PageLoader from '@/compoments/PageLoader'
import { useGetGroupMembersQuery } from '@/services/tenant/workGroups'
import { ROLE_LABELS } from '@/types'
import type { ITeamMember } from '@/types/tenant/team.types'

export const TeamList = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const { id } = useParams()
    const { data, isLoading } = useGetGroupMembersQuery(
        { id: Number(id), qwery: `no_limit=true&${searchParams.toString()}` },
        { skip: !id },
    )
    const pageData = data?.data

    if (isLoading) return <PageLoader />
    return (
        <div
            className="tab flex-auto active-tab overflow-hidden"
            data-id="team-list"
        >
            <div className="table-body table-responsive p-0 flex flex-col">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Full Name</th>
                            <th>Email</th>
                            <th>Team</th>
                            <th>Role</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData?.users && pageData.users.length > 0 ? (
                            pageData.users.map(user => (
                                <tr key={user.id}>
                                    <td>
                                        <UserPart
                                            src={user.photo}
                                            name={user.fullName}
                                            email={user.email}
                                        />
                                    </td>
                                    <td>{user.email}</td>
                                    <td>{user?.team?.name}</td>
                                    <td>
                                        {user.roles.map(role => (
                                            <span
                                                key={role}
                                                className="role-label"
                                            >
                                                {ROLE_LABELS[role]}
                                            </span>
                                        ))}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5}>
                                    <h4 className="text-center">
                                        Users not found
                                    </h4>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
